<span class="label label-accepted" *ngIf="state === ACCEPTED">Accepted</span>
<span class="label label-activated" *ngIf="state === ACTIVE">Active</span>
<span class="label label-ended" *ngIf="state === ENDED">Closed</span>

